import { createContext, useContext, useEffect } from 'react';

/**
 * Lets a page ask the app shell to drop the navbar on a phone while some
 * state lasts - a practice session's focus mode - rather than for a whole
 * route, which is what `AppLayout`'s `hideNavbarOnPhone` does.
 *
 * Outside `AppLayout` (a component story) there is no shell and the request
 * is a no-op.
 */
export const PhoneChromeContext = createContext<
  ((hidden: boolean) => void) | null
>(null);

/** While `active`, the shell hides its navbar below `md`. */
export function useHideNavbarOnPhone(active: boolean) {
  const setHidden = useContext(PhoneChromeContext);
  useEffect(() => {
    if (!setHidden || !active) return;
    setHidden(true);
    return () => setHidden(false);
  }, [setHidden, active]);
}
